import React from "react";
import PropTypes from "prop-types";
import Investor from "./investor";
import Util from "../../../common/util";

function InvestorList(props) {
  const { investors } = props;

  return investors.length > 0 && (
    <section className='row d-flex justify-content-center' id='investors' name='investors'>
      <div className='col-12 col-sm-10'>
        <h2>
          INVESTORS
        </h2>
        <div className='row'>
          {Util.arrayInGroupOfArray(investors, 3).map(group => {
            return (
              group.map(user => {
                return (
                  <Investor
                    {...props}
                    key={user.id}
                    user={user}
                  />
                );
              })
            );
          })}
        </div>
      </div>
    </section>
  );
}

InvestorList.propTypes = {
  investors: PropTypes.arrayOf(PropTypes.object)
};

InvestorList.defaultProps = {
  investors: []
};

export default InvestorList;
